import { createContext, useContext, useState, type ReactNode } from "react";

export type PredefinedAction = { id: string; label: string; description?: string };

const INITIAL_PREDEFINED: PredefinedAction[] = [
  { id: "review_approve", label: "Review & Approve" },
  { id: "create_task", label: "Create Task" },
  { id: "onboard_employee", label: "Onboard Employee" },
  { id: "generate_report", label: "Generate Report" },
  { id: "sync_data", label: "Sync Data" },
];

type AppContextValue = {
  predefined: PredefinedAction[];
  setPredefined: React.Dispatch<React.SetStateAction<PredefinedAction[]>>;
};

const AppContext = createContext<AppContextValue | null>(null);

export function AppProvider({ children }: { children: ReactNode }) {
  const [predefined, setPredefined] = useState<PredefinedAction[]>(INITIAL_PREDEFINED);

  return (
    <AppContext.Provider value={{ predefined, setPredefined }}>{children}</AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside AppProvider");
  return ctx;
}
